import Vue from 'vue'

import FormSearchTicket from './FormSearchTicket.vue'

// Allow multiple Vue apps in the same page
const appElements = document.querySelectorAll('.vue-form-search-ticket')
Array.from(appElements).forEach(element => {
  /* eslint-disable no-new */
  new Vue({
    el: element,
    render: h => h(FormSearchTicket)
  })
})
